interface VersionFileInfo {
  fileName: string;
  size?: number;
  uploadedAt?: string;
}

/**
 * Finds a file in the latest version files by fileName
 * @param latestVersionFiles - Array of files from the latest version
 * @param fileName - Name of the file to find
 * @returns The file if found, undefined otherwise
 */
export function findFileInVersion<T extends VersionFileInfo>(
  latestVersionFiles: T[],
  fileName: string
): T | undefined {
  return latestVersionFiles.find((f) => f.fileName === fileName);
}

/**
 * Gets file size from latest version files
 * @param latestVersionFiles - Array of files from the latest version
 * @param fileName - Name of the file
 * @returns File size or 0 if not found
 */
export function getFileSizeFromVersion(
  latestVersionFiles: VersionFileInfo[],
  fileName: string
): number {
  const file = findFileInVersion(latestVersionFiles, fileName);
  return file?.size || 0;
}

/**
 * Gets file uploadedAt date from latest version files
 * @param latestVersionFiles - Array of files from the latest version
 * @param fileName - Name of the file
 * @returns Uploaded date string or empty string if not found
 */
export function getFileUploadedAtFromVersion(
  latestVersionFiles: VersionFileInfo[],
  fileName: string
): string {
  const file = findFileInVersion(latestVersionFiles, fileName);
  return file?.uploadedAt || '';
}
